import React from 'react'
import Feature from './Feature'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'

const PlanFeatures = (props) => (
  <div className='pl4'>
    {props.plan === 'premium' && <div>
    {props.cancellationDate !== null && <Feature feature={[<FormattedMessage id="plan.serviceEndDate"/> , ': ' + moment(props.cancellationDate).format('YYYY-MM-DD')]}/>}
    {props.nextInvoiceDate !== null && <Feature feature={[<FormattedMessage id="plan.nextBillingDate"/> , ': ' + moment(props.nextInvoiceDate).format('YYYY-MM-DD')]}/>}
    {props.failedPaymentCount > 0 && <div>
      <Feature feature={[<FormattedMessage id="plan.failedCount"/> , ': ' + props.failedPaymentCount]}/>
      <Feature feature={[<FormattedMessage id="plan.failedDate"/> , ': ' + moment(props.failedPaymentDate).format('YYYY-MM-DD')]}/>
      </div>}
      {props.max_rooms > 0 && <Feature feature={<FormattedMessage id="PlanDetails.numberOfRooms" values={{n: props.max_rooms}}/>}/>}
      {props.max_accounts > 0 && <Feature feature={<FormattedMessage id='PlanDetails.accountNumbers' values={{n: props.max_accounts}}/>}/>}
    </div>}
  </div>
)

export default PlanFeatures



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/PlanFeatures.js